module.exports = __webpack_public_path__ + "img/top10-bn2.9435f2ab.png";